type ErrorLike = {
  type?: unknown
  message?: unknown
}

export const USER_ABORT_GRACE_MS = 15_000

const ABORT_LIKE_PATTERN =
  /\b(abort(?:ed|ing)?|cancel(?:ed|led|ling|ing)?|interrupt(?:ed|ing)?|stop(?:ped|ping)?)\b|stopped by user|user stop/i

// Claude Code sidecar emits a diagnostic error when the user interrupts a run.
// The message contains "[ede_diagnostic]" with "result_type=user".
const CLAUDE_CODE_USER_INTERRUPT_PATTERN =
  /\bede_diagnostic\b.*\bresult_type\s*=\s*user\b/i

function isAbortLikeText(value: unknown): boolean {
  return typeof value === "string" && ABORT_LIKE_PATTERN.test(value)
}

function isClaudeCodeUserInterruptMessage(value: unknown): boolean {
  return typeof value === "string" && CLAUDE_CODE_USER_INTERRUPT_PATTERN.test(value)
}

export function isAbortLikeError(error: ErrorLike | null | undefined): boolean {
  if (!error) return false
  return isAbortLikeText(error.type) || isAbortLikeText(error.message) || isClaudeCodeUserInterruptMessage(error.message)
}

export function isAbortLikeFinishReason(reason: unknown): boolean {
  return isAbortLikeText(reason)
}
